import { gql } from "@apollo/client";

export const CHECK_EXIST_BY_RELATED_NO = gql`
    query CheckExistByRelatedNo($pickupSerialNo: String, $trackingNumber: String) {
        checkExistByRelatedNo(pickupSerialNo: $pickupSerialNo, trackingNumber: $trackingNumber)
    }
`;

export interface CheckExistByRelatedNoResponse {
    checkExistByRelatedNo: string | null;
}

